import { createAsyncThunk } from "@reduxjs/toolkit";
import DirectToConsumerService from "../../services/DirectToConsumerService";

export const fetchPurchasePackageThunks = createAsyncThunk(
    "purchasePackage/fetchPurchasePackageThunks",
    async (_,{ rejectWithValue }) => {
        try {
            const response = await DirectToConsumerService.purchasePackage();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'An error occurred');
        }
    }
);
